import { createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../../service/Api";

export const addToCart = createAsyncThunk(
    "cart/addToCart",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await Api.post("/create_medallionsecret", payload);
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { message: "Failed to add to cart" }
            );
        }
    }
);

export const verifyPayment = createAsyncThunk(
    "cart/verifyPayment",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await Api.post("/verify_medallion", payload);
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { message: "Payment verification failed" }
            );
        }
    }
);